module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "block column is-half is-offset-one-quarter"
  }, [_c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onClickpersonal()
      }
    }
  }, [_vm._v("Personal Details")]), _vm._v(" "), _c('button', {
    staticClass: "button is-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.onClickprofile()
      }
    }
  }, [_vm._v("Profile")])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.personal && _vm.userInForm) ? _c('div', {
    staticClass: "column animated"
  }, [_c('div', {
    staticClass: "is-ancestor tile"
  }, [_c('div', {
    staticClass: "tile is-parent column is-half is-offset-one-quarter"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Update Personal Details ")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.username),
      expression: "userInForm.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.userInForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Email")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.email),
      expression: "userInForm.email"
    }],
    staticClass: "input",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.userInForm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("First Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.first_name),
      expression: "userInForm.first_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "First Name"
    },
    domProps: {
      "value": (_vm.userInForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.last_name),
      expression: "userInForm.last_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Last Name"
    },
    domProps: {
      "value": (_vm.userInForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success",
    on: {
      "click": function($event) {
        _vm.onUpdateUser(_vm.userInForm)
      }
    }
  }, [_vm._v("\n                Update\n              ")])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.profile && _vm.user.profile) ? _c('div', {
    staticClass: "column animated"
  }, [_c('div', {
    staticClass: "is-ancestor tile"
  }, [_c('div', {
    staticClass: "tile is-parent column is-half is-offset-one-quarter"
  }, [_c('article', {
    staticClass: "tile is-child box"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("Update Profile ")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image is-square"
  }, [_c('img', {
    attrs: {
      "src": _vm.user.profile.avatar,
      "alt": "Image"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "media"
  }, [_c('div', {
    staticClass: "media-content"
  }, [_c('p', {
    staticClass: "title is-4"
  }, [_vm._v(_vm._s(_vm.userInForm.username))]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-6"
  }, [_vm._v("Profile Picture")])])])])]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Username")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.username),
      expression: "userInForm.username"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Username"
    },
    domProps: {
      "value": (_vm.userInForm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Nation I.D")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.first_name),
      expression: "userInForm.first_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "I.D"
    },
    domProps: {
      "value": (_vm.userInForm.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.first_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('label', {
    staticClass: "label"
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userInForm.last_name),
      expression: "userInForm.last_name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Phone Number"
    },
    domProps: {
      "value": (_vm.userInForm.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userInForm.last_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button is-success"
  }, [_vm._v("\n                Update\n              ")])])])])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a0007bc"}!./client/views/profile/template.html
// module id = 225
// module chunks = 17